module.exports = __webpack_public_path__ + "img/stress_buster.7ceb31ec.png";